import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { AgedDebtorReportSVG } from '../../../../svgComponents/agedDebtorReportSVG';
import { BankStatementSVG } from '../../../../svgComponents/bankStatementSVG';
import { BusinessPlanSVG } from '../../../../svgComponents/businessPlanSVG';
import { FiledAccountsSVG } from '../../../../svgComponents/filedAccountsSVG';
import { ManagementAccountsSVG } from '../../../../svgComponents/managementAccountsSVG';
import { VATReturnSVG } from '../../../../svgComponents/vatReturnSVG';
import { DOCUMENT_UPLOADER } from '../documentUploader/DocumentUploader.actions';
import messages from './ChooseDocumentType.messages';
import styles from './ChooseDocumentType.module.css';
import { DocumentTypeAction } from './documentTypeAction/DocumentTypeAction';
import _ from 'lodash';
import { getApplicantFirstName } from '../../../../api/lendingAPI/CustomerStateAPIHelper';
import { RootState } from '@iwProvider/configureStore';
import { Dispatch } from 'redux';
import { TDocumentTypes } from '../UploadDocumentsModalHelper';

const mapStateToProps = ({ api }: RootState) => ({
    firstName: getApplicantFirstName(api.customer_state.data)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToDocumentUploader: (documentType: TDocumentTypes[number]) =>
        dispatch({ type: DOCUMENT_UPLOADER, documentType })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

class ChooseDocumentType extends Component<
    PropsFromRedux & { documentTypes: TDocumentTypes }
> {
    handleDocumentTypeSelection = (documentType: TDocumentTypes[number]) => {
        this.props.goToDocumentUploader(documentType);
    };

    handleIconSelection = (document: { value: string }) => {
        switch (document.value) {
            case 'bank statement':
                return BankStatementSVG;
            case 'aged debtor report':
                return AgedDebtorReportSVG;
            case 'invoices':
                return FiledAccountsSVG;
            case 'business plan':
                return BusinessPlanSVG;
            case 'management accounts':
            case 'trade certificate':
                return ManagementAccountsSVG;
            case 'vat return':
            case 'personal id':
            case 'shareholder id':
            case 'share registry':
            case 'other':
            default:
                return VATReturnSVG;
        }
    };

    renderDocuments() {
        const { documentTypes } = this.props;

        return _.map(
            documentTypes,
            (document: TDocumentTypes[number], documentKey: number) => {
                if (document && !document.hideFromSelection) {
                    return (
                        <DocumentTypeAction
                            key={documentKey}
                            documentType={document.value}
                            onClick={() =>
                                this.handleDocumentTypeSelection(document)
                            }
                            label={
                                <FormattedMessage
                                    {...messages[
                                        document.label as keyof typeof messages
                                    ]}
                                />
                            }
                            icon={this.handleIconSelection(document)}
                        />
                    );
                }
            }
        );
    }

    render() {
        const documents = this.renderDocuments();

        return (
            <div>
                <div className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </div>
                <div className={styles.actions}>{documents}</div>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(ChooseDocumentType);
